import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import classnames from 'classnames'
import MyShortInfo from '../components/MyShortInfo/MyShortInfo'
import { setSidebarOpen } from '../store/slices/appSlice'
import Logo from '../components/Logo'

const Sidebar = () => {
  const dispatch = useDispatch()
  const { pages, sidebarOpen } = useSelector((state) => state.app)
  const { showWebsiteLinkInSidebar, dividerAboveLogOutInMeny } = useSelector(
    (state) => state.app.appSettings,
  )
  const toggleSidebar = () => {
    dispatch(setSidebarOpen(!sidebarOpen))
  }

  const menuItems = useMemo(
    () =>
      _(pages)
        .filter((page) => page.menuTitle)
        .map((page) => (
          <li key={page.url} className={` ${page.divider ? 'divider' : ''}`}>
            <NavLink
              onClick={() => dispatch(setSidebarOpen(false))}
              to={page.url}
              target={
                ['http', 'https'].some((protocol) => page.url.startsWith(protocol))
                  ? '_blank'
                  : '_self'
              }
            >
              <i className={`icon icon-geblod_ikon_${page.icon}`} />
              {page.menuTitle}

              {page.menuTitle === 'Kontakta oss' && (
                <i className="icon small-icon icon-geblod-ikon-external-link" />
              )}
            </NavLink>
          </li>
        ))
        .value(),
    [dispatch, pages],
  )

  const clearSessionLogin = () => {
    sessionStorage.setItem('login', false)
  }

  return (
    <div id="sidebar" className={classnames('sidebar', { open: sidebarOpen })}>
      <div className="sidebar__container">
        <div className="sidebar__inner">
          <div className="upper">
            <MyShortInfo />
            <nav className="menu">
              <ul>
                {menuItems}
                <li className={` ${dividerAboveLogOutInMeny ? 'divider' : ''}`}>
                  <NavLink tabIndex="0" to="/auth/logout" onClick={clearSessionLogin}>
                    <i className="icon icon-geblod_ikon_loggaut" />{' '}
                    {__.trans('sidebar.logout-title')}
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
          <div className="lower">
            {showWebsiteLinkInSidebar && (
              <div className="go-home">
                <span>
                  <i className="icon icon-geblod_ikon_pil" />
                  <span>
                    <a href="https://geblod.nu" tabIndex="0">
                      {__.trans('sidebar.go-to-geblod')}
                    </a>
                  </span>
                </span>
              </div>
            )}

            <Logo />
          </div>
        </div>
      </div>
      <div className="sidebar__overlay" onClick={toggleSidebar} />
    </div>
  )
}

export default Sidebar
